import { cn } from '@/lib/utils';

export interface FilterSegmentOption<T extends string | number> {
	value: T;
	label: string;
}

interface FilterSegmentFieldProps<T extends string | number> {
	label: string;
	value: T;
	options: readonly FilterSegmentOption<T>[];
	onChange: (value: T) => void;
	className?: string;
}

export default function FilterSegmentField<T extends string | number>({
	label,
	value,
	options,
	onChange,
	className,
}: FilterSegmentFieldProps<T>) {
	return (
		<div className={cn('grid gap-1.5', className)}>
			<span className='text-sm text-foreground'>{label}</span>
			<div className='flex flex-wrap gap-1.5' role='group' aria-label={label}>
				{options.map(opt => {
					const active = value === opt.value;
					return (
						<button
							key={String(opt.value)}
							type='button'
							onClick={() => onChange(opt.value)}
							aria-pressed={active}
							className={cn(
								'shrink-0 h-8 px-2.5 rounded-md text-xs border transition-colors',
								active
									? 'bg-secondary border-border text-foreground font-medium'
									: 'bg-transparent border-border/60 text-muted-foreground hover:text-foreground',
							)}
						>
							{opt.label}
						</button>
					);
				})}
			</div>
		</div>
	);
}
